import React from 'react';
import { Link } from 'react-router-dom';
import './header.styles.scss';
import SocialShare from './../socialshare/socialshare.component';
import logo from './logo.png';

const Header = () => {
  return (
    <div className="header">
      <Link className="title--link" to="/">
        <h1 className="title"><img className="logo" src={logo} alt="Logo" />COVID-19 PANDEMIC</h1>
      </Link>
      <SocialShare />
    </div>
  );
}

export default Header;